export * from './nelegalInfo.component';
